import React from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'utils/axios';
import AuthService from 'services/AuthService';
import {
  MenuItem
} from '@mui/material';

const Logout = () => {
  const navigate = useNavigate();

  const handleLogout = async() => {

    

                var response = await axios.delete("auth-middleware/"+AuthService.getToken(),{params: {username:  AuthService.getUsername()
                }});


                if (response.status === 204) {AuthService.logout();
                  navigate('/login');
                } else {
                }
    
    //navigate('/login');
  };

  return (
       <MenuItem
                onClick={handleLogout}
                sx={{
                  '&:hover': {
                    backgroundColor: '#e3f2fd',
                    color: '#0a58ca',
                  },
                }}
              >
                Logout
              </MenuItem>
      
  );
};

export default Logout;
